import E9ToolBar from '../ecology9/E9ToolBar';

const E8ToolBar = (props) => {
    return (
        <div className="e8header-toolbar">
            <E9ToolBar {...props}/>
        </div>
    );
};

export default E8ToolBar;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology8/E8ToolBar.js